module.exports = __webpack_public_path__ + "img/fairy_light_1.c58580a7.png";